import Link from "next/link";

import { getDefaultBuildYourOwnShopNumber } from "@stadium/redux-utils/selectors/configSelector";
import { useConfig } from "@stadium/hooks/lib/use-config";
import { useWorkspaceContext } from "@stadium/hooks/lib/workspace";

import Multimedia from "@sharedComponents/multimedia";
import Button from "@sharedComponents/buttons";

import { getCreateNewShopRoute } from "@stadium/helpers/app-routes";

import styles from "@styles/dashboard/banner-with-cta.module.scss";

const BuildOwnTemplateBanner = ({ data, onTemplateSelect = () => {}, className = "" }) => {
  const {
    primaryText: title,
    ctaData: { ctaText, secondaryCtaText, secondaryAnchorLink, additionalText },
    image,
    description,
  } = data;
  const buildYourOwnShopNumber = useConfig(getDefaultBuildYourOwnShopNumber);
  const { workspaceSlug } = useWorkspaceContext();
  const createShopUrl = getCreateNewShopRoute({
    shopNumber: buildYourOwnShopNumber,
    workspaceSlug,
  });

  const renderDescription = () => (
    <div className={styles.bannerTemplateDescription}>
      {description}
      <Link href={secondaryAnchorLink} passHref target="_blank" rel="noopener noreferrer">
        {secondaryCtaText}
      </Link>
      {additionalText}
    </div>
  );

  const renderCta = () => (
    <Button
      styleType="primary"
      onClick={() => onTemplateSelect(createShopUrl, true)}
      className={styles.templateBannerCta}
    >
      {ctaText}
    </Button>
  );

  return (
    <section className={`${styles.bannerWrapper} ${className}`}>
      <div className={styles.colText}>
        <div className={styles.title}>{title}</div>
        {renderDescription()}
        <div className={styles.templateBannerCtaRow}>{renderCta()}</div>
      </div>

      <div className={styles.imageBlock}>
        <Multimedia type="image" src={image} alt="" />
      </div>
    </section>
  );
};

export default BuildOwnTemplateBanner;
